

import React from 'react';
import {
    withStyles,
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import DeviceEventEmitter, { EventName } from '../../control/event';
 
class Barrage extends React.Component {


    componentDidMount() {
        DeviceEventEmitter.on(EventName.EVENT_BARRAGE_MSG, this.addBarrage, this);
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.EVENT_BARRAGE_MSG, this.addBarrage, this);
    }

    addBarrage = (msg) => {
        this.shoot(msg);
    }

    shoot = (text) => {
        this.dom = document.getElementById('barrage-wrapper');
        this.dom.style.overflow = 'hidden';
        let rect = this.dom.getBoundingClientRect();
        this.domWidth = rect.right - rect.left;
        this.domHeight = rect.bottom - rect.top;

        let div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.left = this.domWidth + 'px';
        div.style.top = (this.domHeight / 2) * +Math.random().toFixed(2) + 'px';
        div.style.whiteSpace = 'nowrap';
        div.style.color = '#FFF';// + Math.floor(Math.random() * 0xffffff).toString(16);
        div.innerText = text;
        this.dom.appendChild(div);

        let roll = (timer) => {
            let now = +new Date();
            roll.last = roll.last || now;
            roll.timer = roll.timer || timer;
            let left = div.offsetLeft;
            let rect = div.getBoundingClientRect();
            if (left < (rect.left - rect.right)) {
                this.dom.removeChild(div);
            } else {
                if (now - roll.last >= roll.timer) {
                    roll.last = now;
                    left -= 3;
                    div.style.left = left + 'px';
                }
                requestAnimationFrame(roll);
            }
        }
        roll(100 * +Math.random().toFixed(2));
    }

    render() {
        return (<div id='barrage-wrapper' style={{ position: 'absolute', zIndex: 1000, width: '100vw', height: '100%' }} ></div>);
    }
}
export default withRouter(withStyles((theme) => ({

}))(Barrage));
